import { deviceRequestGuard, deviceRequestSiren, } from 'console/redux/devices/items/actions';
export function getGuardControl(device_id, guard_state) {
    if (!guard_state) {
        return null;
    }
    const id = 0;
    const control_type = 'guard';
    const onGuardControlClick = (value) => deviceRequestGuard(device_id, value);
    return {
        id,
        control_type,
        onGuardControlClick,
    };
}
export function getSirenControl(device_id, siren) {
    if (siren == null) {
        return null;
    }
    const id = 1;
    const control_type = 'siren';
    const onGuardControlClick = (value) => deviceRequestSiren(device_id, value);
    return {
        id,
        control_type,
        onGuardControlClick,
    };
}
export function getLegacyGuardControlsConfig(device) {
    const { id, siren: siren_config, guard_state } = device;
    const siren = getSirenControl(id, siren_config);
    const guard = getGuardControl(id, guard_state);
    return [siren, guard];
}
